import Observation from './Observation';
export default Observation;
